import React, { useState, useEffect, useContext } from "react";

import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";
import Volumes from "./Volumes";
import { SPopupContext } from "App/common/hoc/SlidingPopup";
import { objectToArray, formatBytes } from "utils";

function Drives(props) {
  const [collapse, setCollapse] = useState({});
  const { sPopupMethods, sPopupState } = useContext(SPopupContext);
  const sPopupRef = React.useRef();

  useEffect(() => {
    const temp = { ...collapse };
    for (let key in props.list) {
      if (!temp[key]) temp[key] = false;
    }
    setCollapse(temp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /*****************************Handling  popup using enter key ***************************/
  useEffect(() => {
    sPopupRef.current = sPopupState;
    const handleKeyDown = e => {
      if (
        e.key === "Enter" &&
        sPopupRef.current.popup.show &&
        sPopupRef.current.popup.alertName === "uncheckBootableVolume"
      ) {
        sPopupRef.current.popup.params.execute();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    // Cleanup: Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [sPopupState]);

  function toggleCollapseHandler(id) {
    setCollapse(prevState => ({
      ...prevState,
      [id]: !prevState[id]
    }));
  }

  function toggleSourceDevice(e, deviceId) {
    e.stopPropagation();
    e.preventDefault();

    let bootableVolume = false;
    for (let key in props.list[deviceId].volume) {
      if (
        props.list[deviceId].volume[key].bootable &&
        props.list[deviceId].volume[key].checked
      )
        bootableVolume = true;
    }

    if (bootableVolume)
      sPopupMethods.openPopup("uncheckBootableVolume", {
        execute: () => {
          props.toggleSourceDevice(deviceId);
          sPopupMethods.closePopup();
        }
      });
    else props.toggleSourceDevice(deviceId);
  }

  return (
    <ul className="mss_source_drives_ul">
      {objectToArray(props.list).map((val, i) => {
        const collapseTooltip = collapse[val.deviceId]
          ? TOOLTIPS.backupSettings.expand
          : TOOLTIPS.backupSettings.collapse;
        return (
          <li key={i}>
            <div className="source_drives_item">
              <div
                className={[
                  "source_drives_item__body",
                  "flex_align",
                  val.semiChecked ? "semiactive" : "",
                  collapse[val.deviceId] ? "active" : null
                ].join(" ")}
                onClick={() => toggleCollapseHandler(val.deviceId)}
              >
                <Tooltip {...collapseTooltip}>
                  <span className="accordion_icon" />
                </Tooltip>
                <div
                  className="checkbox_wrapper"
                  onClick={e => {
                    toggleSourceDevice(e, val.deviceId);
                  }}
                >
                  <div className="check big">
                    <input
                      type="checkbox"
                      className={
                        "input_checkbox" +
                        (val.checked && window.browserName === "ie"
                          ? " ie_checked"
                          : "")
                      }
                      id={"source_wrapper" + i}
                      defaultChecked={val.checked}
                    />
                    <label htmlFor={"source_wrapper" + i} />
                  </div>
                </div>
                <div className="source_drives_item__icon">
                  <span className="icon" />
                </div>
                <div className="source_drives_item__info">
                  <p>{val.deviceName}</p>
                </div>
                <div className="source_drives_data">
                  <span className="sd_used_data">
                    {formatBytes(val.usedSpace)}
                  </span>
                  <span className="sd_used"> used of</span>
                  <span className="sd_total_data">
                    {formatBytes(val.totalSpace)}
                  </span>
                </div>
              </div>

              <Volumes deviceId={val.deviceId} driveI={i} />
            </div>
          </li>
        );
      })}
    </ul>
  );
}

export default Drives;
